export default "__VITE_ASSET__CubKhLLC__"